'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteElement = exports.setElementType = exports.updateElement = exports.updateMultipleElements = exports.createElementWithId = undefined;

var _timeUtil = require('../utils/timeUtil');

var _elementConstants = require('./elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Utils
var createElementWithId = exports.createElementWithId = function createElementWithId(_ref) {
    var id = _ref.id,
        elementType = _ref.elementType,
        location = _ref.location,
        _ref$content = _ref.content,
        content = _ref$content === undefined ? {} : _ref$content,
        acl = _ref.acl,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync,
        modified = _ref.modified,
        _ref$meta = _ref.meta,
        meta = _ref$meta === undefined ? {} : _ref$meta,
        transactionId = _ref.transactionId,
        duplicate = _ref.duplicate;
    return {
        type: TYPES.ELEMENT_CREATE,
        id: id,
        elementType: elementType,
        location: location,
        content: content,
        meta: meta,
        modified: modified || (0, _timeUtil.getTimestamp)(),
        acl: acl,
        sync: sync,
        transactionId: transactionId,
        duplicate: duplicate
    };
};

// Constants
var updateMultipleElements = exports.updateMultipleElements = function updateMultipleElements(_ref2) {
    var updates = _ref2.updates,
        _ref2$sync = _ref2.sync,
        sync = _ref2$sync === undefined ? true : _ref2$sync,
        transactionId = _ref2.transactionId;
    return {
        type: TYPES.ELEMENT_UPDATE,
        updates: updates,
        sync: sync,
        modified: (0, _timeUtil.getTimestamp)(),
        transactionId: transactionId
    };
};

var updateElement = exports.updateElement = function updateElement(_ref3) {
    var id = _ref3.id,
        changes = _ref3.changes,
        _ref3$sync = _ref3.sync,
        sync = _ref3$sync === undefined ? true : _ref3$sync,
        transactionId = _ref3.transactionId;
    return updateMultipleElements({
        updates: [{ id: id, changes: changes }],
        sync: sync,
        transactionId: transactionId
    });
};

var setElementType = exports.setElementType = function setElementType(_ref4) {
    var id = _ref4.id,
        elementType = _ref4.elementType,
        _ref4$sync = _ref4.sync,
        sync = _ref4$sync === undefined ? true : _ref4$sync,
        transactionId = _ref4.transactionId;
    return {
        type: TYPES.ELEMENT_SET_TYPE,
        id: id,
        elementType: elementType,
        sync: sync,
        transactionId: transactionId
    };
};

var deleteElement = exports.deleteElement = function deleteElement(_ref5) {
    var id = _ref5.id,
        location = _ref5.location,
        _ref5$sync = _ref5.sync,
        sync = _ref5$sync === undefined ? true : _ref5$sync,
        transactionId = _ref5.transactionId;
    return {
        type: TYPES.ELEMENT_DELETE,
        id: id,
        location: location,
        sync: sync,
        transactionId: transactionId
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementActions.js
// module id = 793
// module chunks = 0